import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { bindActionCreators } from 'redux';
import NavigationStateManager from '../../../../helpers/NavigationStateManager';

import get from 'lodash.get';
import { cloneDeep } from 'lodash';

import * as programActions from '../../store/vipProgramActions';

import { Record } from '../../../../modules/bin/utility';
import * as templateBuilderActions from '../../../../modules/template-builder-ex';
import { formBuilderActions } from '../../../../components/formbuilder/store';

import BasePage from '../../../../components/common/basePageView';
import clear from '../../../../components/clear';
import { withRouterV6 } from '../../../../helpers/withRouterV6';
import { withPageTitle } from '../../../../hocs';
import ApplicationTemplate from '../templateEx';
import RecordResultMessage from '../../../../components/common/recordResult';
import { TemplateOptions } from '../../../../components/template/templateOptions';
import Spinner from '../../../../components/common/spinner';
import SavedEntityModal from '../../../../components/common/savedEntityModal';
import Button from '../../../../components/common/button';
import { EntityHeaderActions } from '../../../../components/common/EntityHeaderActions/EntityHeaderActions';
import { History, RefreshCw, ExternalLink, Eye, Edit3 } from 'lucide-react';

import { paths } from '../constants/template';
import { eventAmbassadorStatus, viewModes } from '../../constants';
import { CONTEXT_MENU_KEYS } from '../../../../constants/contextMenuEntries';

class EditApplication extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isApplicationPartTwoVisible: true,
      viewMode: viewModes.VIEW,
      isChangeLinkedPageModalOpen: false,
      isSaveModalOpen: false
    };

    const eventAmbassadorId = get(props, 'match.params.id');

    props.programActions.getEventAmbassadorRecord(eventAmbassadorId);
  }

  onEditClick = () => {
    this.setState({ viewMode: viewModes.EDIT });
  };

  onCancelEdit = () => {
    this.setState({ viewMode: viewModes.VIEW });
  };

  componentDidUpdate(prevProps) {
    // A status change can charge, fail or skip the registration fee on the server, so reload
    // once it finishes to show the outcome.
    if (
      Record.isRecordLoading(prevProps.editEventAmbassadorStatusRecord) &&
      !Record.isRecordLoading(this.props.editEventAmbassadorStatusRecord)
    ) {
      this.props.programActions.getEventAmbassadorRecord(
        get(this.props, 'match.params.id')
      );
    }

    // Show save modal when save succeeds
    if (
      !prevProps.editApplicationRecord?.success?.show &&
      this.props.editApplicationRecord?.success?.show
    ) {
      this.setState({ isSaveModalOpen: true, viewMode: viewModes.VIEW });
    }
  }

  handleCloseSaveModal = () => {
    this.setState({ isSaveModalOpen: false });
    this.clearMessages();
  };

  handleOpenChangeLinkedPageModal = () => {
    this.setState({ isChangeLinkedPageModalOpen: true });
  };

  handleCloseChangeLinkedPageModal = () => {
    this.setState({ isChangeLinkedPageModalOpen: false });
  };

  onSave = (data) => {
    this.props.programActions.updateApplicationRecord(data);
  };

  onCancel = () => {
    this.goToApplicationsView();
  };

  initTemplate = () => {
    let eventAmbassador = cloneDeep(
      get(this.props, 'eventAmbassadorRecord.data.data')
    );
    const campaignAmbassadorProgram = get(
      this.props,
      'eventAmbassadorRecord.data.data.campaignAmbassadorProgram'
    );

    const templateOptions = new TemplateOptions();

    if (
      eventAmbassador.status !== eventAmbassadorStatus.CLAIMED &&
      eventAmbassador.status !== eventAmbassadorStatus.RESCINDED
    ) {
      templateOptions.hide(paths.PART_TWO_HEADER);
      templateOptions.hide(paths.APPLICATION_CONFIRMATION);

      this.setState({
        isApplicationPartTwoVisible: false
      });
    }

    if (!get(eventAmbassador, 'template.value.formBuilder.additional')) {
      templateOptions.hide(paths.APPLICATION_ADDITIONAL);
      templateOptions.hide(paths.OGRANIZATION_QUESTIONS_HEADER);
    }

    if (!campaignAmbassadorProgram.availability.updatingEntries) {
      templateOptions.disable(paths.EDIT_BUTTON);
    }

    templateOptions.setModel(eventAmbassador);

    templateOptions.isEdit();

    this.props.templateBuilderActions.setTemplateModel(
      templateOptions.getWithRule()
    );
  };

  isAllRecordsReady = () => {
    return Record.isRecordReady(this.props.eventAmbassadorRecord);
  };

  clearMessages = () => {
    this.props.programActions.clearRecordMessages('editApplicationRecord');
  };

  clearStatusMessages = () => {
    this.props.programActions.clearRecordMessages(
      'editEventAmbassadorStatusRecord'
    );
  };

  goToApplicationsView = () => {
    const returnUrl = NavigationStateManager.getReturnUrl();
    this.props.history.push(returnUrl || '/vip-program/applications');
  };

  render() {
    if (!this.isAllRecordsReady()) {
      return <Spinner />;
    }

    const isSaving = Record.isRecordLoading(this.props.editApplicationRecord);

    if (!this.props.isTemplateInited) {
      this.initTemplate();
    }

    const eventAmbassadorProgramName = get(
      this.props.eventAmbassadorRecord,
      'data.data.eventAmbassadorProgram.name'
    );

    const fundraiserId = get(
      this.props.eventAmbassadorRecord,
      'data.data.fundraiser.id'
    );
    const fundraiserUrlFull = get(
      this.props.eventAmbassadorRecord,
      'data.data.fundraiser.urlFull'
    );
    const eventAmbassadorStatus = get(
      this.props.eventAmbassadorRecord,
      'data.data.status'
    );
    const campaignAmbassadorProgram = get(
      this.props.eventAmbassadorRecord,
      'data.data.campaignAmbassadorProgram'
    );
    const isEditDisabled = eventAmbassadorStatus === 'Claimed' || 
      !get(campaignAmbassadorProgram, 'availability.updatingEntries');

    const actionMenuItems = [
      ...(this.props.isSystemAdmin && fundraiserId ? [
        {
          key: CONTEXT_MENU_KEYS.PROGRAM.CHANGE_APPLICATION_LINKED_PAGE.key,
          label: I18n.t('applications.template.page.partOne.change-page-modal.header'),
          icon: <RefreshCw aria-hidden="true" />,
          onSelect: this.handleOpenChangeLinkedPageModal,
          systemOnly: true
        },
        {
          key: CONTEXT_MENU_KEYS.PROGRAM.APPLICATION_LINKED_PAGE_EDIT.key,
          label: I18n.t('applications.template.actions.edit-fundraising-page'),
          icon: <Edit3 aria-hidden="true" />,
          href: CONTEXT_MENU_KEYS.PROGRAM.APPLICATION_LINKED_PAGE_EDIT.getUrl({ fundraiserId }, {}),
          target: '_blank',
          systemOnly: true
        },
        { type: 'separator', key: 'sep-1' },
        {
          key: 'view-fundraising-page',
          label: I18n.t('applications.template.actions.view-fundraising-page'),
          icon: <ExternalLink aria-hidden="true" />,
          href: fundraiserUrlFull,
          target: '_blank',
          systemOnly: true
        },
        {
          key: CONTEXT_MENU_KEYS.PROGRAM.APPLICATION_LINKED_PAGE_VIEW_DETAILS.key,
          label: I18n.t('applications.template.actions.view-page-details'),
          icon: <Eye aria-hidden="true" />,
          linkTo: CONTEXT_MENU_KEYS.PROGRAM.APPLICATION_LINKED_PAGE_VIEW_DETAILS.getUrl({ fundraiserId }, {}),
          systemOnly: true
        },
        { type: 'separator', key: 'sep-2' },
      ] : []),
      ...(this.props.isSystemAdmin ? [{
        key: CONTEXT_MENU_KEYS.PROGRAM.AUDIT_TRAIL.key,
        label: I18n.t('campaign.performance.header.audit-trail'),
        icon: <History aria-hidden="true" />,
        linkTo: CONTEXT_MENU_KEYS.PROGRAM.AUDIT_TRAIL.getUrl({ id: get(this.props, 'match.params.id') }, {}),
        systemOnly: true
      }] : [])
    ];

    const editAction = !isEditDisabled && this.state.viewMode === viewModes.VIEW ? {
      key: 'edit-application',
      label: I18n.t('applications.template.page.partOne.edit-button-name.label'),
      icon: <Edit3 aria-hidden="true" />,
      onSelect: this.onEditClick,
      writeAction: true
    } : undefined;

    return (
      <BasePage>
        <RecordResultMessage
          record={this.props.editApplicationRecord}
          onDismiss={this.clearMessages}
        />

        <RecordResultMessage
          record={this.props.editEventAmbassadorStatusRecord}
          onDismiss={this.clearStatusMessages}
        />

        <SavedEntityModal
          open={this.state.isSaveModalOpen}
          isEdit
          pageEditTitle={I18n.t('applications.template.saved-modal.title')}
          content={I18n.t('applications.template.saved-modal.content')}
          buttons={
            <Button
              className="primary"
              onClick={this.goToApplicationsView}
            >
              {I18n.t('applications.template.saved-modal.return-button')}
            </Button>
          }
          onClose={this.handleCloseSaveModal}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h1>
            <Translate
              value={I18n.t('applications.template.header', {
                programName: eventAmbassadorProgramName
              })}
            />
          </h1>
          {this.state.viewMode === viewModes.VIEW && (actionMenuItems.length > 0 || editAction) && (
            <EntityHeaderActions
              editAction={editAction}
              menuItems={actionMenuItems}
              actionsLabel={I18n.t('campaign.performance.header.actions')}
              saveReturnUrl={false}
            />
          )}
        </div>
        <ApplicationTemplate
          onSave={this.onSave}
          isLoading={isSaving}
          onCancel={this.onCancel}
          onCancelEdit={this.onCancelEdit}
          isApplicationPartTwoVisible={this.state.isApplicationPartTwoVisible}
          viewMode={this.state.viewMode}
          onEditClick={this.onEditClick}
          isChangeLinkedPageModalOpen={this.state.isChangeLinkedPageModalOpen}
          onCloseChangeLinkedPageModal={this.handleCloseChangeLinkedPageModal}
        />
      </BasePage>
    );
  }
}

const mapState = ({ program, templateBuilderEx, session }) => {
  return {
    eventAmbassadorRecord: program.eventAmbassadorRecord,
    campaignAmbassadorProgramRecord: program.eventAmbassadorRecord.campaignAmbassadorProgramRecord,
    editApplicationRecord: program.editApplicationRecord,
    editEventAmbassadorStatusRecord: program.editEventAmbassadorStatusRecord,
    isTemplateInited: templateBuilderEx.inited,
    isSystemAdmin: session.isSystemAdmin
  };
};

const mapDispatch = (dispatch) => {
  return {
    programActions: bindActionCreators(programActions, dispatch),
    templateBuilderActions: bindActionCreators(
      templateBuilderActions,
      dispatch
    ),
    formBuilderActions: bindActionCreators(formBuilderActions, dispatch)
  };
};

const titleResolver = (props) => {
  const id = get(props, 'match.params.id') || '';
  const step = get(props, 'match.params.step', '');
  const stepTitle = step ? ` | ${step.charAt(0).toUpperCase() + step.slice(1).replace(/-/g, ' ')}` : '';
  return I18n.t('page-titles.vip-programs.view-application', { id });
};

const EditApplicationContainer = clear(
  connect(mapState, mapDispatch)(EditApplication)
);
export default withRouterV6(withPageTitle(titleResolver)(EditApplicationContainer));
